<template>
    <Header></Header>
    <Left></Left>
    <section class="container">
        <div>
            <div class="area_title">
                <p>비밀번호 변경</p>
            </div>
            <div class="area_body">
                <div class="area_section">
                    <div class="area_form">
                        <div class="area_form_body">
                            <div class="area_row">
                                <div class="area_col_head"><label>아이디</label></div>
                                <div class="area_col_body">
                                    <p v-text="state.id"></p>
                                </div>
                            </div>

                            <div class="area_row">
                                <div class="area_col_head"><label>비밀번호</label></div>
                                <div class="area_col_body">
                                    <div class="">
                                        <input type="password" v-model="state.pw" />
                                    </div>
                                </div>
                            </div>

                            <div class="area_row">
                                <div class="area_col_head"><label>비밀번호</label></div>
                                <div class="area_col_body">
                                    <div class="">
                                        <input type="password" v-model="state.pw_re" />
                                    </div>
                                </div>
                            </div>

                            <div class="area_row">
                                <div class="area_col_head"><label>이름</label></div>
                                <div class="area_col_body">
                                    <p v-text="state.name"></p>
                                </div>
                            </div>

                            <div class="area_row">
                                <div class="area_col_head"><label>권한</label></div>
                                <div class="area_col_body">
                                    <p v-text="state.auth"></p>
                                </div>
                            </div>

                            <div class="area_row">
                                <div class="area_col_head"><label>담당</label></div>
                                <div class="area_col_body">
                                    <p v-text="state.auas"></p>
                                </div>
                            </div>

                            <div class="area_row">
                                <div class="area_col_head"><label>부서</label></div>
                                <div class="area_col_body">
                                    <p v-text="state.team"></p>
                                </div>
                            </div>
                        </div>

                        <div class="area_form_foot">
                            <div class="area_button">
                                <button type="button" class="active" @click="confirmModify">저장</button>
                                <button type="button" class="" @click="reset">초기화</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <ModalDefault
        v-if="state.isShowModal"
        :type="state.modalTab"
        :title="state.modalTitle"
        :content="state.modalContent"
        @close="closeModal"
        @callback="callbackModal"
    ></ModalDefault>
</template>
<script lang="ts" config>
    import {
        Left,
        Header,
        reactive,
        apiService,
        onMounted,
        router,
        ModalDefault,
        types,
        getMessageByCode,
        CommonUtils,
        CommonOptions,
        ItemAdd,
        watch,
        useRoute,
        userStore,
    } from "@/BaseComponent";

    export default {
        components: { ModalDefault, ItemAdd, Left, Header },

        setup() {
            const route = useRoute();
            const user = userStore();
            const state = reactive({
                idx: 0 as number,
                data: {} as types.admin.AdminVOForApi,

                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalIsResult: false as boolean,
                modalTitle: "alert" as string,
                modalContent: "" as string,
                id: "" as string,
                pw: "" as string,
                pw_re: "" as string,
                name: "" as string,
                auth: 0 as number,
                auas: "" as string,
                dept: null as 1 | 3 | 5 | 6 | null,
                team: "" as string,
            });

            onMounted(() => {
                me();
            });

            const reset = () => {
                me();
            };

            const me = async () => {
                const res = await apiService.base.me();

                if (res.returnCode === 0) {
                    const data: types.admin.AdminVOForApi = res.data;

                    state.idx = data.idx;
                    state.id = data.id;
                    state.name = data.name;
                    state.auth = data.auth;
                    state.auas = data.auas;
                    state.dept = data.dept;
                    state.team = data.team;

                    state.pw = "";
                    state.pw_re = "";
                } else {
                    console.error(res.description);
                }
            };

            const showModal = () => {};

            const closeModal = () => {
                if (state.modalTab === 3) {
                    router.back();
                } else {
                    state.isShowModal = false;
                }
            };

            const callbackModal = (param: any) => {
                if (param.action === "confirm") {
                    modify();
                } else if (param.action === "callback") {
                    me();
                    state.isShowModal = false;
                }
            };

            const confirmModify = () => {
                if (state.pw === "") {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "비밀번호를 입력해주세요.";
                    state.isShowModal = true;
                    return;
                } else if (state.pw_re === "") {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "비밀번호를 입력해주세요.";
                    state.isShowModal = true;
                    return;
                } else if (state.pw !== state.pw_re) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "비밀번호가 다릅니다.";
                    state.isShowModal = true;
                    return;
                } else if (!CommonUtils.regexForPassword.test(state.pw)) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "비밀번호 형식이 올바르지 않습니다.";
                    state.isShowModal = true;
                    return;
                }

                state.modalTab = 1;
                state.modalTitle = "알림";
                state.modalContent = "정말 변경하시겠습니까?";
                state.isShowModal = true;
            };

            const modify = async () => {
                const param: types.admin.ReqChangePw = {
                    pw: state.pw,
                };

                const res = await apiService.base.changePw(param);
                if (res.returnCode === 0) {
                    state.modalTab = 3;
                    state.modalTitle = "알림";
                    state.modalContent = "수정되었습니다.";
                    state.isShowModal = true;
                } else {
                    console.error(res.description);
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            return {
                state,
                router,
                reset,
                CommonUtils,
                CommonOptions,
                showModal,
                closeModal,
                callbackModal,
                confirmModify,
            };
        },
    };
</script>
<style scoped>
    div.area_col_body > div:not(:where(.radio-wrap, .select-wrap, .datepicker, .area_file, .file_list)) {
        width: 100%;
    }
    input[type="date"] {
        width: auto;
    }
    textarea,
    input[type="text"] {
        width: 100%;
    }
    textarea {
        min-height: 100px;
    }
</style>
